"use strict";

exports.__esModule = true;
exports.CycleClassifyBetweenOccurs = void 0;
var _core = require("@blueprintjs/core");
var _react = _interopRequireWildcard(require("react"));
var _CommonValidators = require("../utils/CommonValidators");
var _styles = require("../styles");
var _vimanaTypes = require("@vimana/vimana-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var CycleClassifyBetweenOccurs = exports.CycleClassifyBetweenOccurs = function CycleClassifyBetweenOccurs(_ref) {
  var _condition$conditionB, _condition$conditionB2;
  var condition = _ref.condition,
    updateSelf = _ref.updateSelf;
  return /*#__PURE__*/_react["default"].createElement(_styles.Row, null, /*#__PURE__*/_react["default"].createElement("span", null, "occurs for utmost "), /*#__PURE__*/_react["default"].createElement(_core.InputGroup, _extends({
    "data-testid": "ConditionFreeText",
    value: (_condition$conditionB = condition.conditionBetween) == null ? void 0 : _condition$conditionB.time,
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    onChange: function onChange(_ref2) {
      var target = _ref2.target;
      return updateSelf(Object.assign({}, condition, {
        conditionBetween: Object.assign({}, condition.conditionBetween, {
          time: target.value
        })
      }));
    }
  }, !(0, _CommonValidators.validateEmptyField)((_condition$conditionB2 = condition.conditionBetween) == null ? void 0 : _condition$conditionB2.time) && {
    intent: _core.Intent.DANGER
  })));
};